export const IDB_DATABASE_NAME = 'speechify-web-db-zustand';
